import React, { useEffect } from "react";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
} from "@mui/material";
import PrintData from "../../../components/common/section/printData";

const ViewSubsectionTable = ({
  fetchContentData,
  subsection,
  section,
  language,
}) => {
  const [content, setContent] = React.useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetchContentData({
          subsection: subsection.subsection,
          section,
          language,
        });
        setContent(response.data);
      } catch (error) {
        console.error("Error fetching content data:", error);
      }
    };
    fetchData();
  }, [subsection, section, language]);

  return (
    <Box sx={{ position: "relative" }}>
      <Box
        sx={{
          position: "sticky",
          top: 0,
          zIndex: 10,
          backgroundColor: "white",
          padding: "10px",
          paddingBottom: "30px",
        }}
      >
        <PrintData fileName={`${subsection.subsection}.pdf`} />
      </Box>
      <Box sx={{ padding: "20px", borderBottom: "2px solid #D3D3D3", }}>
        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 650 }} aria-label="faq table">
            <TableHead>
              <TableRow>
                <TableCell sx={{ fontSize: "1.25rem" }}>
                  <strong>अ.क्र.</strong>
                </TableCell>
                <TableCell sx={{ fontSize: "1.25rem" }}>
                  <strong>प्रश्न</strong>
                </TableCell>
                <TableCell sx={{ fontSize: "1.25rem" }}>
                  <strong>उत्तर</strong>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {content.map((row, index) => (
                <TableRow key={index}>
                  <TableCell sx={{ fontSize: "1.1rem" }}>
                    {row["अ.क्र."]}
                  </TableCell>
                  <TableCell sx={{ fontSize: "1.1rem" }}>
                    {row["प्रश्न"]}
                  </TableCell>
                  <TableCell sx={{ fontSize: "1.1rem" }}>
                    {row["उत्तर"]}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    </Box>
  );
};

export default ViewSubsectionTable;
